import Intro from './sections/Intro';
import Portfolio from './sections/Portfolio';

function App() {
  return (
    <div className="App ">
      <Intro />
      <Portfolio />
    </div>
  );
}

export default App;
